import {Component, computed, inject, OnInit} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {Router} from '@angular/router';
import {take} from 'rxjs';
import {ListFilterIcon, LucideAngularModule} from 'lucide-angular';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivitiesPreviewComponent} from '@domain/activity/component/activities-preview/activities-preview.component';
import {PlacePipe} from '@domain/place/pipe/place.pipe';
import {
  ActivitySearchFiltersComponent
} from '@public/activity/search-activity/components/activity-search-filters/activity-search-filters.component';
import {RouteGenerator} from '@core/route-generator';
import {
  ActivitySearchService
} from '@public/activity/search-activity/components/activity-search-filters/activity-search.service';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-activity-search',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    ActivitiesPreviewComponent,
    LucideAngularModule,
    ActivitySearchFiltersComponent
  ],
  providers: [
    PlacePipe
  ],
  templateUrl: './search-activity.component.html',
  styleUrl: './search-activity.component.scss'
})
export class SearchActivityComponent implements OnInit {


  private readonly router = inject(Router);
  private readonly searchService = inject(ActivitySearchService);
  private readonly placePipe = inject(PlacePipe);
  public readonly routes = {
    home: RouteGenerator.abs(UI_ROUTES.public.dashboard)
  };

  public readonly icons = {
    Filter: ListFilterIcon
  };

  public showFilters = false;
  public searchResponse = toSignal(this.searchService.searchResponse$, {initialValue: null});
  public location = computed(() => {
    const response = this.searchResponse();
    if (response?.town) {
      return this.placePipe.transform(response.town);
    }
    return null;
  });

  public ngOnInit(): void {
    this.loadSearch();
  }

  public hideFilters(): void {
    this.showFilters = false;
  }

  public resetFilters(): void {
    this.searchService.resetFilters();
  }

  public toggleShowFilters(): void {
    this.showFilters = !this.showFilters;
  }

  private loadSearch(): void {
    const searchResponse = this.searchService.getSearchResponse();
    if (!searchResponse) {
      this.searchService.search(true)
        .pipe(take(1))
        .subscribe(response => {
          if (!response) {
            this.router.navigate([this.routes.home]).then(_ok =>  {});
          }
        });
    }
  }

}
